import type { CSSProperties } from "react";

import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import src from "./ListeningLottie.json?url";

export function ListeningAnimation({ style }: { style?: CSSProperties }) {
    // The 24x24 asset is square; a <canvas> has no intrinsic ratio, so pin it while honoring the caller's width.
    return <DotLottieReact style={{ aspectRatio: "1 / 1", ...style }} src={src} loop autoplay speed={1} />;
}
